var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    fillRule: "nonzero",
    d: "M12 19.5c-.876 0-1.722-.102-2.535-.275l-3.531 2.122.047-3.479C3.275 16.241 1.5 13.55 1.5 10.5c0-4.97 4.701-9 10.5-9s10.5 4.03 10.5 9c0 4.971-4.701 9-10.5 9zm-12-9c0 3.314 1.759 6.265 4.5 8.19v4.323a.556.556 0 0 0 .844.475l4.413-2.678c.727.12 1.476.19 2.243.19 6.627 0 12-4.701 12-10.5C24 4.702 18.627 0 12 0S0 4.702 0 10.5zm17.25-2.25H6.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 1 0 0-1.5zm-1.5 4.5h-7.5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 1 0 0-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.d992e7e5.svg";
export { ForwardRef as ReactComponent };